import { jsxs as l, Fragment as C, jsx as e } from "react/jsx-runtime";
const o = () => /* @__PURE__ */ l(C, { children: [
  /* @__PURE__ */ e(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.25 2C5.00736 2 4 3.00736 4 4.25V19.25C4 20.4926 5.00736 21.5 6.25 21.5H17.25C18.4926 21.5 19.5 20.4926 19.5 19.25V6H15V2H6.25ZM17.0303 10.0303C17.3232 9.73744 17.3232 9.26256 17.0303 8.96967C16.7374 8.67678 16.2626 8.67678 15.9697 8.96967L11 13.9393L9.03033 11.9697C8.73744 11.6768 8.26256 11.6768 7.96967 11.9697C7.67678 12.2626 7.67678 12.7374 7.96967 13.0303L10.4697 15.5303C10.6103 15.671 10.8011 15.75 11 15.75C11.1989 15.75 11.3897 15.671 11.5303 15.5303L17.0303 10.0303Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ e(
    "path",
    {
      d: "M17.586 2.58601C17.2109 2.21094 16.702 2 16.1716 2H16V5H19.4728C19.4047 4.59123 19.2105 4.21053 18.9138 3.91376L17.586 2.58601Z",
      fill: "currentColor"
    }
  )
] });
export {
  o as default
};
